<mat-tab-group mat-align-tabs="center" dynamicHeight animationDuration="0ms" color="accent">
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tabIcon">group</mat-icon>
            Members
        </ng-template>
        <ng-template matTabContent>
            <app-email-recipients></app-email-recipients>
        </ng-template>
    </mat-tab>
    <mat-tab>
        <ng-template mat-tab-label>
            <mat-icon class="tabIcon">groups</mat-icon>
            Groups
        </ng-template>
        <ng-template matTabContent>
            <app-legislation-groups></app-legislation-groups>
        </ng-template>
    </mat-tab>
</mat-tab-group>
